import React from "react";
import { StyledButton } from "../HeaderStyles";
import StarIcon from "../../../icons/StarIcon";
import PublishDialog from "../header-types/status-header/DraftPublishing/publish-dialog/PublishDialog";
import Tooltip from "@hyro-components/Tooltip";
import { usePublishButton } from "./PublishButton.hook";
import { PUBLISH_BUTTON } from "./PublishButton.consts";
import { CircularProgress } from "@mui/material";

const PublishButton = () => {
  const {
    publishConfirmationOpen,
    isPublishDisabled,
    isPublishing,
    isLoading,
    getButtonTooltip,
    handleClickPublish,
    openPublishDialog,
    closePublishDialog
  } = usePublishButton();

  const getIcon = () => {
    if (isLoading) {
      return <CircularProgress size={16} sx={{ color: "grey.400" }} />;
    }

    return <StarIcon disabled={isPublishDisabled} />;
  };

  return (
    <>
      <Tooltip title={getButtonTooltip()} tooltipStyle={{ maxWidth: 160 }} testId="publish-button">
        <StyledButton
          data-testid="publish-button"
          disabled={isPublishDisabled}
          variant="contained"
          startIcon={getIcon()}
          color="secondary"
          sx={{
            border: theme => `1px solid ${theme.palette.tertiary[300]}`
          }}
          onClick={openPublishDialog}
        >
          {isPublishing ? PUBLISH_BUTTON.PUBLISHING_TEXT : PUBLISH_BUTTON.PUBLISH_TEXT}
        </StyledButton>
      </Tooltip>
      <PublishDialog
        open={publishConfirmationOpen}
        onClose={closePublishDialog}
        handleSubmit={handleClickPublish}
      />
    </>
  );
};

export default PublishButton;
